exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".features-grid[data-v-ec0955c0]{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:.75rem 2rem}.feature-flag .form-text[data-v-ec0955c0]{margin-left:1.5rem;margin-top:0}", ""]);

// exports
